export default "/build/frontend/fonts/vendor/@fontsource/inter/files/inter-latin-ext-400-normal.woff?1c20f7dc20d731a18fcdc65d45a3c30b";